import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, retry} from 'rxjs/operators';
import {HttpErrorHandler} from '../../http.error.handler';
import {environment} from '../../../environments/environment';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ChangelogService {

  constructor(
    private readonly http: HttpClient,
  ) { }

  async getChangelog(application: string) {
    return await firstValueFrom(
      this.http.get(`${environment.services.service}v1/changelog/${application}`, {responseType: 'text'}).pipe(
        retry(0),
        catchError((error) => {
          if (error.status === 404) {
            // Return empty string or throw a custom error
            throw { status: 404, message: 'Changelog not found' };
          }
          return HttpErrorHandler.handleError(error);
        })
      )
    );
  }
}
